module.exports = "<p>bulk-cand-res-log works!</p>\n"